import { CONFIG_UPDATE } from 'Reducers/config/types';
import { SET_ENV } from 'Reducers/env/types';
import { INITIALIZATION_ERROR } from 'Reducers/nav/types';
import { setLsapiCountryRedirectUrl, setUrls } from 'Utilities/dataHelpers';
import { getSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
const handleInitializationError = (error, queryParams) => {
  const {
    redirect_uri
  } = queryParams || {};
  store?.dispatch({
    type: INITIALIZATION_ERROR,
    initErrorStatus: error.status,
    initErrorCode: error.code,
    redirect_uri
  });
};

/**
 * Handles region mismatch errors to update the API base URL and retry the initialization
 * @param error - Axios error containing the 'x-api-url' header response (redirect url)
 * @param handleSubmit - Callback function to retry the call
 */
const handleWrongRegionError = async (error, handleSubmit, queryParams) => {
  const redirectUrl = error.response?.headers?.['x-api-url'];
  if (!redirectUrl) {
    handleInitializationError(error, queryParams);
    return;
  }
  setLsapiCountryRedirectUrl(redirectUrl);
  await handleSubmit();
};
const root = async pageCtx => {
  const queryParams = pageCtx.query;
  try {
    await setupInitialization(queryParams);
  } catch (err) {
    const error = err;
    if (error.response?.status === 400) {
      await handleWrongRegionError(error, () => root(pageCtx), queryParams);
      return;
    }
    const {
      redirect_uri
    } = queryParams || {};
    store?.dispatch({
      type: INITIALIZATION_ERROR,
      initErrorStatus: error.status,
      initErrorCode: error.code,
      redirect_uri
    });
  }
};
const setupInitialization = async queryParams => {
  const envSession = getSessionObject('env');
  const configSession = getSessionObject('config');
  if (!queryParams && envSession && configSession) {
    store.dispatch({
      type: CONFIG_UPDATE,
      config: configSession
    });
    store.dispatch({
      type: SET_ENV,
      env: envSession
    });
    setUrls(configSession, envSession.country);
    return;
  }
  const {
    country,
    app,
    pId,
    redirect_uri,
    cid
  } = queryParams || {};
  await updateConfig(country, app, pId, redirect_uri, cid);
};

// Create your paths that you want to handle here
// you want to most specific earlier and the least specific later
// Note: if one action throws an error (calls promise reject) then the handlePaths
// will move onto the next matching route
const routeActions = [{
  regex: [/^\.*/],
  action: root
}];
export const handlePaths = ctx => {
  const doActions = [];
  for (const check of routeActions) {
    for (const r of check.regex) {
      if (ctx.canonicalPath.match(r)) {
        // Add valid actions to chain later
        doActions.push(check.action);
      }
    }
  }

  // Start with a rejected promise
  let p = Promise.reject();

  // Build a negative promise chain that will try the next action if the previous one failed
  // Once an action succeeds the chain ends and the app starts
  for (let i = 0; i < doActions.length; i++) {
    p = p.catch(() => doActions[i](ctx));
  }
  return p;
};